<script setup>
import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import iconPen from "@/assets/grammar/fill_icon.png";
import audioPlay from "@/assets/grammar/audio_play.svg";
import audioPause from "@/assets/grammar/audio_pause.png";
import audioPlaying1 from "@/assets/grammar/audio_playing1.png";
import audioPlaying2 from "@/assets/grammar/audio_playing2.png";
import translate from "@/assets/grammar/icon-translate.svg";
import translate_h from "@/assets/grammar/icon-translate_h.svg";
import { insetIconPen, replaceTags } from "@/views/grammar/js/TagAnalysis";
import { ref, onMounted, nextTick } from "vue";
import { textToPlayAudio } from "@/js/textToPlayAudio";
import store from "@/js/store";

const props = defineProps(["templateData"]);

const ossUrl = `${store.getOEMBASE() || ""}grammar_content/`;

const audioStatus = ref(null);

const audioSentencePath = ref(null);

const audioTimer = ref(null);

const currentId = ref(null);

const audioPlaySentenceRef = ref();

const previewImgSrc = ref();

const photoProviderRef = ref();

const list = ref([]);

//播放句子发音
function handleAudio(data) {
  if (currentId.value !== data.id) {
    currentId.value = data.id;
    audioStatus.value = "end";
    window.clearInterval(audioTimer.value);
    audioTimer.value = null;
    audioSentencePath.value = null;
    list.value.forEach((item) => {
      item.count2List.forEach((answer) => {
        answer.audioIcon = audioPlay;
      });
    });
  }

  const audioText = data.sentence.replace(/<\/?[^>]+>/g, "");
  let num = 0;
  if (audioStatus.value !== "playing") {
    const regex = /\s*\([^)]*\)/g; //匹配文本中的括号
    const result = audioText.trim().replace(regex, ""); // 替换匹配的内容为空字符串
    textToPlayAudio(result, (url) => {
      if (!audioSentencePath.value) {
        audioSentencePath.value = url;
        audioPlaySentenceRef.value.oncanplay = function () {
          audioPlaySentenceRef.value.play();
        };
      } else {
        audioPlaySentenceRef.value.play();
      }
      data.audioIcon = audioPlaying1;
      if (!audioTimer.value) {
        audioTimer.value = setInterval(() => {
          data.audioIcon = ++num % 2 ? audioPlaying1 : audioPlaying2;
        }, 300);
      }
      audioPlaySentenceRef.value.onplaying = function () {
        audioStatus.value = "playing";
      };
      audioPlaySentenceRef.value.onended = function () {
        audioStatus.value = "end";
        window.clearInterval(audioTimer.value);
        audioTimer.value = null;
        data.audioIcon = audioPlay;
        audioSentencePath.value = null;
      };
    });
  } else {
    audioStatus.value = "paused";
    window.clearInterval(audioTimer.value);
    audioTimer.value = null;
    data.audioIcon = audioPause;
    audioPlaySentenceRef.value.pause();
  }
}

function downloadIamge() {
  const a = document.createElement("a");
  a.href = previewImgSrc.value;
  a.download = previewImgSrc.value;
  a.click();
  a.remove();
}

function previewImg(imageUrl) {
  previewImgSrc.value = ossUrl + imageUrl;
  photoProviderRef.value.visible = true;
}

// 处理内容中的特殊标签
const processContent = (content) => {
  return replaceTags(content);
};

onMounted(() => {
  list.value = props.templateData.content[0].count1List.map((item) => {
    item.syntax = item.syntax ? processContent(item.syntax) : "";
    item.count2List.forEach((ans) => {
      ans.id = Math.floor(10000 + Math.random() * 90000);
      ans.showTranslate = false;
      ans.audioIcon = audioPlay;
      ans.sentence = ans.sentence ? processContent(ans.sentence) : "";
    });
    return item;
  });
});
</script>

<template>
  <InnerContainer :title="templateData.pageTitle" :sub-title="templateData.problem">
    <div v-for="(item, index) in list" :key="index" class="template-item">
      <p class="template-article">
        <span class="template-article_syntax" v-html="item.syntax"></span>
      </p>
      <ul>
        <li v-for="(ans, idx) in item.count2List" :key="idx">
          <div class="article-item">
            <span style="flex: 1" v-html="ans.sentence"></span>
            <span v-if="ans.sentence" class="tool-item">
              <img class="tool-icon" :src="ans.audioIcon" alt="" @click="handleAudio(ans, item)" />
              <img
                v-if="ans.imageUrl"
                class="tool-icon"
                style="width: 1.15rem; height: 1.15rem"
                src="@/assets/grammar/icon-img.svg"
                alt=""
                @click="previewImg(ans.imageUrl)"
              />
              <img
                class="tool-icon"
                :src="!ans.showTranslate ? translate_h : translate"
                @click="ans.showTranslate = !ans.showTranslate"
              />
            </span>
          </div>
          <p v-if="ans.translation && ans.showTranslate" class="translate-text">
            {{ ans.translation }}
          </p>
        </li>
      </ul>
    </div>
    <div
      class="explanation-box white-underline"
      v-if="templateData.content[0].explanation"
      style="color: white"
      v-html="processContent(templateData.content[0].explanation)"
    ></div>
    <audio id="audioPlay" ref="audioPlaySentenceRef" :src="audioSentencePath">播放句子</audio>

    <!--    图片预览    -->
    <photo-provider
      ref="photoProviderRef"
      :photo-closable="true"
      :default-backdrop-opacity="0.6"
      :download-method="downloadIamge"
    >
      <photo-consumer :src="previewImgSrc">
        <img :src="previewImgSrc" style="display: none" />
      </photo-consumer>
    </photo-provider>
  </InnerContainer>
</template>

<style scoped lang="less">
.template-item {
  background-color: white;
  border-radius: 0.5rem;
  padding: 1rem;
  color: #3f4140;
  margin-bottom: 1rem;

  .template-article {
    margin: 0 0 0.67rem;
    font-size: 1.14rem;
    font-weight: 400;
    line-height: 1.7rem;

    &_syntax {
      position: relative;
      display: block;
    }
  }

  /deep/ .icon-pen {
    position: relative;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .article-item {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 1.14rem;
    font-weight: 400;
    padding:0.4rem 0;
    &:hover{
      background-color: #f5f5f5;
    }

    .tool-item {
      max-width: 7rem;
      padding-top: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap:0.5rem
    }

    .tool-icon {
      width: 1.3rem;
      height: 1.3rem;
    }
  }

  .translate-text {
    background-color: #f2f3f6;
    border-radius: 0.65rem;
    font-size: 1rem;
    padding: 0.6rem;
    margin-top: 0.68rem;
  }
}

</style>
<style>
.white-underline .underline{
  border-color: white!important;
}
</style>
